import { DateOrTimestamp } from './common';
import { ConnectyCubeUsers } from './users';

export enum LoginProviderNames {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  FIREBASE_PHONE = 'firebase_phone',
  FIREBASE_EMAIL = 'firebase_email',
}

export namespace ConnectyCubeAuth {
  export type Session = {
    id: number;
    user_id: number;
    application_id: string | number;
    token: string;
    ts: DateOrTimestamp;
    created_at: DateOrTimestamp;
    updated_at: DateOrTimestamp;
    user?: ConnectyCubeUsers.User | null;
  };
  export type LoginProviderKeys = { token: string; secret?: string };
  export type LoginFirebaseKeys = { project_id: string | number; access_token: string };
  export type LoginByLogin = { login: string; password: string };
  export type LoginByEmail = { email: string; password: string };
  export type LoginByGuest = { guest: '1'; full_name: string };
  // Login by social providers
  export type LoginByFacebook = {
    provider: LoginProviderNames.FACEBOOK;
    keys: LoginProviderKeys;
  };
  export type LoginByTwitter = {
    provider: LoginProviderNames.TWITTER;
    keys: LoginProviderKeys;
  };
  export type LoginByFirebasePhone = {
    provider: LoginProviderNames.FIREBASE_PHONE;
    firebase_phone: LoginFirebaseKeys;
  };
  export type LoginByFirebaseEmail = {
    provider: LoginProviderNames.FIREBASE_EMAIL;
    firebase_email: LoginFirebaseKeys;
  };
  // Request parameters type
  export type LoginParams =
    | LoginByLogin
    | LoginByEmail
    | LoginByGuest
    | LoginByFacebook
    | LoginByTwitter
    | LoginByFirebasePhone
    | LoginByFirebaseEmail;
  export type GeneratedSessionParams = {
    application_id: string | number;
    auth_key: string;
    user?: LoginByLogin | LoginByEmail | LoginByGuest;
    provider?: LoginProviderNames;
    keys?: LoginProviderKeys;
    firebase_phone?: LoginFirebaseKeys;
    firebase_email?: LoginFirebaseKeys;
  };
  // Response data type
  export type LoginRawResponse = { user: ConnectyCubeUsers.User; [key: string]: any };
  export type GetSessionRawResponse = { session: Session; [key: string]: any };
}
